import translationMap from "~/data/translationMap.json";

function resolveTranslationGroup(slug, locale) {
  if (translationMap[slug]) return translationMap[slug];

  for (const entry of Object.values(translationMap)) {
    if (entry[locale] === slug) return entry;
    if (Object.values(entry).includes(slug)) return entry;
  }

  return null;
}

function buildHreflangPaths(group) {
  const paths = {};
  for (const [lang, slug] of Object.entries(group)) {
    if (slug) paths[lang] = `/${lang}/${slug}`;
  }
  return paths;
}

export function usePostHreflang() {
  const route = useRoute();
  const { locale } = useI18n();
  const slug = route.params.slug;
  const group = resolveTranslationGroup(slug, locale.value);

  if (!group) {
    useHreflang({ [locale.value]: `/${locale.value}/${slug}` });
    return;
  }

  useHreflang(buildHreflangPaths(group));
}
